// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal .modal-dialog {
    min-width: 380px !important;
}

.errormodal-topview {
    border-bottom: 1px solid #98A2B3;
    padding: 30px;
    text-align: center;
}

.errormodal-topview img {
    width: 80px;
    height: 80px;
    object-fit: contain;
    margin-bottom: 20px;
}

.errormodal-topview p {
    font-size: 20px;
    line-height: 30.72px;
    font-family: 'Lora-Regular';
}


.Close-btn {
    border: 1px solid #294859;
    padding: 10px 28px;
    border-radius: 100px;
    background-color: #294859;
    font-size: 16px;
    line-height: 18.8px;
    font-family: 'PublicSans-Regular';
    color: #FFFFFF;
    cursor: pointer;
    margin-top: 30px;
}

@media (max-width:600px) {
    .error-modal .modal-dialog {
        min-width: 300px !important;
    }

    .Close-btn {
        padding: 10px 18px;
        font-size: 14px;
    }
    .modal-topview p {
        font-size: 22px;
        line-height: 28.72px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/ErrorModal/style.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,2BAA2B;AAC/B;;;AAGA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iCAAiC;IACjC,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,eAAe;QACf,oBAAoB;IACxB;AACJ","sourcesContent":[".error-modal .modal-dialog {\n    min-width: 380px !important;\n}\n\n.errormodal-topview {\n    border-bottom: 1px solid #98A2B3;\n    padding: 30px;\n    text-align: center;\n}\n\n.errormodal-topview img {\n    width: 80px;\n    height: 80px;\n    object-fit: contain;\n    margin-bottom: 20px;\n}\n\n.errormodal-topview p {\n    font-size: 20px;\n    line-height: 30.72px;\n    font-family: 'Lora-Regular';\n}\n\n\n.Close-btn {\n    border: 1px solid #294859;\n    padding: 10px 28px;\n    border-radius: 100px;\n    background-color: #294859;\n    font-size: 16px;\n    line-height: 18.8px;\n    font-family: 'PublicSans-Regular';\n    color: #FFFFFF;\n    cursor: pointer;\n    margin-top: 30px;\n}\n\n@media (max-width:600px) {\n    .error-modal .modal-dialog {\n        min-width: 300px !important;\n    }\n\n    .Close-btn {\n        padding: 10px 18px;\n        font-size: 14px;\n    }\n    .modal-topview p {\n        font-size: 22px;\n        line-height: 28.72px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
